import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { applicationLoaded } from '../../actions/application-loaded';

export class AppLoaded extends Component {
  componentDidMount() {
    this.init();
  }

  componentWilReceiveProps({ key }) {
    if (this.props.key !== key) {
      this.cleanUp();
    }
  }

  componentDidUpdate({ key }) {
    if (this.props.key !== key) {
      this.init();
    }
  }

  componentWillUnmount() {
    this.cleanUp();
  }

  init() {
    this.timeout = setTimeout(this.props.applicationLoaded); // Ensures that masonry is rendered
  }

  cleanUp() {
    clearTimeout(this.timeout);
  }

  render() {
    return null;
  }
}

AppLoaded.propTypes = {
  parent: PropTypes.object,
  selector: PropTypes.string,
  key: PropTypes.any,
  applicationLoaded: PropTypes.func,
};

const mapDispatchToProps = {
  applicationLoaded,
};

export default connect(
  undefined,
  mapDispatchToProps,
)(AppLoaded);
